import React from 'react';
import SidebarContainer from '../../components/sideBar/SidebarContainer';
import ContentStatus from './contentStatus/ContentStatus';

const HotelPresentationSideBar = () => {
    return (
        <SidebarContainer>
            <ContentStatus />
        </SidebarContainer>
    );
};

export default HotelPresentationSideBar;
